<style lang="scss" src="./vipicon.scss"></style>

<template>
  <div class="vft-vip-subscript">
    <template v-if="useNewIcon">
      <img :src="iconUrl" alt="" class="img-vip-subscript" @error="isFallback=true">
    </template>
    <template v-else-if="isCompat">
      <i class="vft-vip-icon" :class="levelClass" v-if="payVip.endTime && payVip.endTime !== '' && +new Date(payVip.endTime.replace(/-/g, '/')) > 0">
        <i class="icon_vip_num" v-if="useNum && payVip.level > 0"></i>
      </i>
    </template>
  </div>
</template>

<script>
let canUseWebP = typeof document === 'undefined' ? false : (document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') === 0)
const REG_EXP = /\.(\w+)(\/\d+)?$/
const DEFAULT_EXT = 'png'

export default {
  name: 'VftVipIcon',
  props: {
    payVip: {
      type: Object,
      required: true
    },
    useShort: {
      type: Boolean,
      default: false
    },
    useYearIcon: {
      type: Boolean,
      default: true
    },
    useNum: {
      type: Boolean,
      default: true
    },
    iclass: {
      type: Object
    },
    ext: {
      type: String
    },
    type: {
      type: String
    }
  },
  data () {
    return {
      isFallback: false
    }
  },
  computed: {
    // 等级的角标class
    levelClass () {
      let value = {}

      if (this.useShort || this.payVip.level === 0) {
        value['icon_vip_lv' + this.payVip.level] = true
        if (!this.payVip.vip) { // 过期会员
          value.icon_vip_grey = true
        }
      } else {
        value['icon_vip_lv' + this.payVip.level] = true

        // 年费会员
        if (this.useYearIcon) {
          value['icon_vipyear'] = true
          if (!this.payVip.annualvip) {
            value['icon_yearvip_grey'] = true
          }
          if (!this.payVip.vip) {
            value['icon_vip_grey'] = true
          }
        } else {
          value['icon_vip_l'] = true
          if (!this.payVip.vip) {
            value['icon_vip_grey'] = true
          }
        }
      }

      return Object.assign({}, value, this.iclass)
    },
    originIconUrl () {
      let iconUrl = ''

      if (this.payVip) {
        const iconData = this.payVip[`${this.type || 'composite'}_icon`]
        iconUrl = iconData && iconData.icon_url
      }
      return iconUrl
    },
    originExt () {
      if (!this.originIconUrl) {
        return ''
      }

      const matches = this.originIconUrl.match(REG_EXP)

      return (matches && matches[1]) || ''
    },
    iconUrl () {
      if (!this.originIconUrl) {
        return ''
      }

      let ext = this.ext || (!canUseWebP && this.originExt === 'webp' ? DEFAULT_EXT : '')

      if (this.isFallback || !ext) {
        return this.originIconUrl
      }
      return this.originIconUrl.replace(REG_EXP, `.${ext}$2`)
    },
    useNewIcon () {
      return !this.useShort && this.originIconUrl
    },
    isCompat () {
      return this.type === 'vip' && (this.payVip && this.payVip.level < 8)
    }
  }
}

</script>
